module.exports = __webpack_public_path__ + "img/app_icon_4.0a07bf42.png";